import {
  useEffect, useState,
} from 'react';
import { getWMSOptimizedTerritoriesProgressForStatus } from '~/_shared/components/topUnderbar/WMSOptimizedTerritoriesProgress/WMSOptimizedTerritoriesProgressBar.helpers';
import type { BoundaryCreateWMSOptimizedStatus } from '~/store/frontendState/mapTools/boundary/boundaryCreateWMSOptimized/boundaryCreateWMSOptimized.state';

export const useWMSOptimizedTerritoriesProgressForStatus = (status: BoundaryCreateWMSOptimizedStatus) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const newProgress = getWMSOptimizedTerritoriesProgressForStatus(status);
    if (newProgress < progress) {
      return;
    }

    setProgress(newProgress);
  }, [progress, status]);

  return progress;
};
